import { FC, useCallback } from 'react';
import { PressEvent } from '@react-aria/interactions';

import { Button } from '../Button';

import styles from './SkipLink.module.scss';

export interface SkipLinkProps {
  skipTo?: string;
}

export const SkipLink: FC<SkipLinkProps> = ({ skipTo = 'main:first-of-type' }) => {
  const onClick = useCallback(
    (event: PressEvent) => {
      const target = event.target.id === 'footer-skip-link' ? 'footer' : skipTo;
      const container: HTMLElement | null = document.querySelector(target);

      if (container) {
        container.tabIndex = -1;
        container.focus();
        setTimeout(() => container.removeAttribute('tabindex'), 1000);
      }
    },
    [skipTo]
  );

  return (
    <div className={styles.skipLink}>
      <Button emphasis="tertiary" onPress={onClick} size="sm">
        Skip to main content
      </Button>
      <Button emphasis="tertiary" onPress={onClick} size="sm" id="footer-skip-link">
        Skip to footer
      </Button>
    </div>
  );
};
